import { useLang } from '@/i18n';
import HightlightTextAni from '../HighlightTextAni';

const J: React.FC = () => {
    const { t } = useLang('dpux');

    return <HightlightTextAni id={'delta-pro-ultra-x-J'} title={t('J_title')} desc={t('J_desc')} />;
};

export default J;
